import { ReactNode } from 'react';
import { Link } from '@tanstack/react-router';

import { cx } from '@libs/classnames';
import { HorizontalScroll } from '@ui/components/HorizontalScroll';
import { IconButton } from '@ui/components/IconButton';
import { useMediaQuery } from '@providers/MediaQueryProvider';
import { ArrowHeadIcon } from '@ui/icons/ArrowHeadIcon';

import { IValidRoute } from '@features/shared/utils/router';

import { PlayLogo } from './PlayLogo';

import styles from './PromoNavigation.module.css';

type Props = {
  activeTab: 'clubs' | 'tournaments';
  showStudio?: boolean;
};
export function PromoNavigation({ activeTab, showStudio }: Props) {
  const isMobile = useMediaQuery() === 'mobile';

  return (
    <div className={styles.navigation}>
      {!isMobile && (
        <div className={styles.playLogo}>
          <PlayLogo />
        </div>
      )}

      <HorizontalScroll
        className={styles.navigationRow}
        scrollToSelector=".active"
        scrollToSelectorBlock="center"
      >
        {/* ВАЖНО:
            Не забываем синхронизировать меню с UserSettingsMenuPopover
        */}
        <PromoNavigationTab label="Игра с другом" to="/game/friend" />
        <PromoNavigationTab label="Шахматные клубы" to="/club" isActive={activeTab === 'clubs'} />
        <PromoNavigationTab
          label="Онлайн-турниры"
          to="/tournament"
          isActive={activeTab === 'tournaments'}
        />
        <PromoNavigationTab label="Онлайн-игра с&nbsp;людьми" to="/game/pairing" />
        <PromoNavigationTab label="Игра с компьютером" to="/game/computer" />
        <PromoNavigationTab label="Анализ партий" to="/game/analysis" />
        {showStudio && <PromoNavigationTab label="Студия" to="/studio" />}
      </HorizontalScroll>
    </div>
  );
}

type PromoNavigationTabProps = {
  label: ReactNode;
  to: IValidRoute;
  isActive?: boolean;
  badge?: ReactNode;
  disabled?: boolean;
};
function PromoNavigationTab({ label, to, isActive, badge, disabled }: PromoNavigationTabProps) {
  return (
    <Link
      to={to}
      className={cx(styles.tab, {
        [styles.active]: isActive,
        [styles.disabled]: disabled,
        active: isActive,
      })}
    >
      <div className={styles.title}>{label}</div>
      <div className={styles.status}>
        <div className={styles.badge}>{badge}</div>
        <IconButton size="24" className={styles.arrowButton}>
          <ArrowHeadIcon />
        </IconButton>
      </div>
    </Link>
  );
}
